export default "__VITE_ASSET__CGB74PM___"